import { combineReducers } from 'redux'
import { 
	SET_SEARCH_TEXT,
	SET_SEARCH_RESULTS,
	SET_FIREBASE,
	SET_GOOGLE,
	SET_USER
} from '../actions/index'

const searchText = (state = "", action) => {
	if (action.type === SET_SEARCH_TEXT) {
		return action.searchText;
	}

	return state;
};

const searchResults = (state = [], action) => {
	if (action.type === SET_SEARCH_RESULTS) {
		return action.searchResults;
	}

	return state;
};

const google = (state = null, action) => {
	if (action.type === SET_GOOGLE) {
		return action.google;
	}

	return state;
};

const user = (state = null, action) => {
	if (action.type === SET_USER) {
		return action.user;
	}

	return state;
}

const firebase = (state = null, action) => {
	if (action.type === SET_FIREBASE) {
		return action.firebase;
	}

	return state;
}

const reducer = combineReducers({
	searchText,
	searchResults,
	google,
	user,
	firebase
});

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js